import actions from './actions';

const {
  SEARCHTEXTSUCCESS,

} = actions;

const initialStateList = {
  data: '',
  loading: false,
  error: null,
};

const SearchTextReducer = (state = initialStateList, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SEARCHTEXTSUCCESS:
      return {
        ...initialStateList,
        data,
        loading: false,
      };
    
    default:
      return state;
  }
};

export default SearchTextReducer;
